<template>
	<vs-dropdown class="cbs-color-picker cursor-pointer" vs-custom-content vs-trigger-click>
		<a href.prevent>
			<div v-if="mode === 'default'" class="h-8 w-8 rounded-full cbs-color-picker__icon-picker" :style="{ backgroundColor: activeColorValue }" />
			<i v-else class="text-2xl nucleo nucleo-flag-glyph cbs-color-picker__icon-picker" :style="{ color: activeColorValue }" />
		</a>

		<vs-dropdown-menu>
			<div class="selector cbs-color-picker__selector p-3 sm:p-5 flex flex-wrap">
				<div class="selector__header text-black">
					{{ listHeaderText }}
				</div>
				<div :class="['list selector__list flex', { 'mt-3': listHeaderText }]">
					<div
						:class="[{ 'is-active': value === item.value }, 'list__item cursor-pointer mr-3 last:mr-0']"
						:key="index"
						v-for="(item, index) in colors"
						@click.prevent="handleChangeValue(item.value)"
					>
						<div class="h-8 w-8 rounded" :style="{ backgroundColor: item.value }"></div>
					</div>
				</div>
			</div>
		</vs-dropdown-menu>
	</vs-dropdown>
</template>

<script>
import _ from "lodash";

export default {
	name: "CbsColorPicker",
	props: {
		value: {
			type: [String, Number]
		},
		colors: {
			type: Array,
			validator: prop => {
				if (!_.isEmpty(prop)) {
					return !_.some(prop, item => {
						return !(_.has(item, "id") && _.has(item, "value"));
					});
				}
				return true;
			}
		},
		listHeaderText: {
			type: String,
			default: "Select note color"
		},
		mode: {
			type: String,
			default: "default",
			validator: prop => ["default", "flag"].includes(prop)
		}
	},
	computed: {
		activeColorValue() {
			const activeColor = this.colors.find(item => item.value === this.value);
			return activeColor ? activeColor.value : undefined;
		}
	},
	methods: {
		handleChangeValue(itemId) {
			this.$emit("input", itemId);
		}
	}
};
</script>

<style lang="scss" scoped>
.cbs-color-picker {
	margin-left: -15px;

	a {
		margin-left: 15px;
	}
}

.cbs-color-picker__selector {
	.list__item {
		padding: 0;
		transition: var(--common-transition);

		&.is-active {
			div {
				border: 2px solid var(--color-black);
			}
		}
	}
}
</style>
